"use client";
import React from "react";
import { Hero } from "app/components/hero";
import { HeroButtons } from "app/components/views/home/heroButtons";
import CiscoSdaBanner from "public/cisco-sda/cisco-sda.webp";
import ciscoTopology from "public/cisco-sda/cisco-sda-topology.webp";
import CiscoSdaPricing from "./components/ciscoSdaPricing";
import { SectionDivider } from "app/components/shared/SectionDivider";
import { AspectRatio, Flex } from "@chakra-ui/react";
import Image from "next/image";
import HardwareSoftware from "./components/hardwareSoftware";
import GettingStarted from "./components/gettingStarted";
import AccordionList from "app/components/shared/AccordionList";
import { CISCO_SDA_CONSTANTS, CISCO_SDA_FAQ_LIST } from "./components/constants";
import CustomCarousel from "app/components/shared/CustomCarousel";
import Certificates from "app/components/views/home/Certificates";
import TalkToUs from "app/components/shared/talkToUs";

const CiscoSdaPage = () => {
  return (
    <>
      <Hero
        title="Cisco Software Defined Access"
        description={CISCO_SDA_CONSTANTS.Hero_desc}
        image={CiscoSdaBanner}
        points={CISCO_SDA_CONSTANTS.Hero_points}
      >
        <HeroButtons Pricing />
      </Hero>
      <CiscoSdaPricing />
      <SectionDivider label="Cisco Software-Defined Access Topology" />
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
        mt={5}
        mb={5}
        data-cy="section-topology"
      >
        <Flex
          width={{ base: "full", md: "700px", lg: "800px" }}
          justifyContent="center"
          alignItems={"center"}
        >
          <AspectRatio
            width={"full"}
            ratio={8 / 6}
            position={"relative"}
            border={"1px solid #aaa"}
          >
            <Image
              alt={"Cisco SDA Topology"}
              title={"Cisco SDA Topology"}
              src={ciscoTopology}
              sizes="100vw"
              style={{ objectFit: "contain", objectPosition: "center" }}
            />
          </AspectRatio>
        </Flex>
      </Flex>
      <HardwareSoftware />
      <GettingStarted />
      <SectionDivider label="Some FAQs Before You Buy" />
      <AccordionList items={CISCO_SDA_FAQ_LIST} />
      <Certificates />
      <CustomCarousel />
      <TalkToUs />
    </>
  );
};

export default CiscoSdaPage;
